import { PropertyType } from '../../../common';

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	uids: data.userIds,
	applyGroups: data.activePartners.map((p: PropertyType) => p.value),
	applyProperties: data.activePermissions,
	applyRoles: data.activeRoles,
});
